import { useBoundStore } from 'useStore';
import FilterChip from 'views/Components/Forecast/FilterChip';
import useMotivesData from 'views/Components/Forecast/Queries/motivesQuery';

export default function MotiveFilterChip() {
	const selectedMotive = useBoundStore((state) => state.fhMotive);
	const resetSelectedMotive = useBoundStore((state) => state.resetFhMotive);
	const motivesQuery = useMotivesData();
	const motive = motivesQuery.data?.find((m) => m.id === selectedMotive);

	if (selectedMotive === 0) return null;

	return (
		<FilterChip
			filterName="Motivo"
			title={motive?.motivo_str}
			onDelete={() => resetSelectedMotive()}
		/>
	);
}
